import(/* webpackMode: "eager" */ "/workspace/frameworkassure/src/app/error.tsx");
